.errorStateStyle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  max-width: 640px;
  margin: 0 auto;
  padding: 24px;
  text-align: center;
  flex: 1;
}

.titleStyle {
  margin: 0;
  font-size: 28px;
  font-weight: 500;
  color: var(--tractie-color-content-emphasis);
}

.descriptionStyle {
  margin: 0;
  color: var(--tractie-color-content-emphasis);
}

.subtextStyle {
  color: var(--tractie-color-content-emphasis);
}

.subtextStyle p {
  margin: 0;
}

.actionsStyle {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}
